import { Plug, MessageSquarePlus, Bot } from "lucide-react";
import { Reveal, Overline } from "@/components/primitives";

const STEPS = [
  { n: "01", icon: Plug, title: "Connect and configure", desc: "Add your business and connect the profiles you want to grow. Setup takes minutes, not weeks." },
  { n: "02", icon: MessageSquarePlus, title: "Start collecting reviews", desc: "Share QR codes and let automated requests bring in a steady stream of authentic customer reviews." },
  { n: "03", icon: Bot, title: "Let the AI agents run", desc: "Your agents reply, publish social proof, and expand visibility across search and AI platforms — automatically." },
];

export default function HowItWorks() {
  return (
    <section id="how" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal><Overline>Getting started</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 text-4xl font-black leading-[1.02] tracking-tighter text-black sm:text-5xl lg:text-6xl">
              Up and running in days
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-[10px] border border-black/10 bg-black/10 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1} className="bg-white p-8 lg:p-10">
              <div className="flex items-center justify-between">
                <span className="text-5xl font-black tracking-tighter text-black/10">{s.n}</span>
                <div className="flex h-12 w-12 items-center justify-center rounded-[10px] bg-black text-white">
                  <s.icon size={20} />
                </div>
              </div>
              <h3 className="mt-8 text-xl font-semibold tracking-tight text-black">{s.title}</h3>
              <p className="mt-3 text-base font-light leading-relaxed text-black/60">{s.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
